// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X--M","type":"styles_type__2QB09","choices":"styles_choices__2evGx"};